import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { feesMasterKeys } from '../feesMasterQueryKeys'
import { createFeeDefinition } from '../feesMasterEndpoints'

export function useCreateFeeDefinitionMutation() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: createFeeDefinition,
    onSuccess: () => qc.invalidateQueries({ queryKey: feesMasterKeys.lists() }),
  })
}
